import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { MapPin } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/pas-bank-statement/address`;
const inp = 'px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm';

export const AddressPrompt = ({ token, onSaved, prefix = 'address' }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  const h = { headers: { Authorization: `Bearer ${token}` } };
  useEffect(() => {
    axios.get(API, { headers: { Authorization: `Bearer ${token}` } }).then(r => setF(r.data)).catch(() => {});
  }, [token]);
  if (!f?.missing) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const r = await axios.put(API, { address: f.address, city: f.city, state: f.state, zip_code: f.zip_code }, h);
      toast.success(r.data.message); setF({ ...f, missing: false }); onSaved?.();
    } catch (err) { toast.error(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Check the address: 2-letter state and 5-digit ZIP'); }
    setBusy(false);
  };
  return (
    <form onSubmit={save} className="bg-amber-500/10 border border-amber-500/40 rounded-2xl p-4 mb-6 space-y-3" data-testid={`${prefix}-prompt`}>
      <p className="text-amber-200 text-sm font-medium flex items-center gap-2"><MapPin className="w-4 h-4" /> Add your address so your account statements are complete</p>
      <div className="grid sm:grid-cols-4 gap-2">
        <input value={f.address} onChange={set('address')} placeholder="Street address" className={`${inp} sm:col-span-2`} data-testid={`${prefix}-street`} required />
        <input value={f.city} onChange={set('city')} placeholder="City" className={inp} data-testid={`${prefix}-city`} required />
        <div className="flex gap-2">
          <input value={f.state} onChange={set('state')} placeholder="ST" maxLength={2} className={`${inp} w-16 uppercase`} data-testid={`${prefix}-state`} required />
          <input value={f.zip_code} onChange={set('zip_code')} placeholder="ZIP" className={`${inp} flex-1 min-w-0`} data-testid={`${prefix}-zip`} required />
        </div>
      </div>
      <button disabled={busy} className="px-4 py-2 bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white rounded-lg text-sm font-semibold" data-testid={`${prefix}-save-btn`}>Save address</button>
    </form>
  );
};
